import type { ContractStatusEnum, PriceListMtrRowData } from 'gql/graphql';
import { Loader } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';

import { PriceListMtrRowMenu } from '../PriceListMtrRowMenu';

import Styles from './PriceListMtr.module.css';

interface ICodeCellRendererComponent extends ICellRendererParams<PriceListMtrRowData> {
    contractStatus: ContractStatusEnum | undefined;
}

export const MtrCodeCellRendererComponent = ({ contractStatus, data }: ICodeCellRendererComponent) => {
    if (!data) {
        return <Loader />;
    }

    return (
        <div className={Styles.wrapperMenu}>
            <PriceListMtrRowMenu row={data} contractStatus={contractStatus} />
        </div>
    );
};

MtrCodeCellRendererComponent.displayName = 'MtrCodeCellRendererComponent';
